import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { Collision } from "@/types/collision.type";

const API_URL = `${import.meta.env.VITE_API_URL}/collisions`;

const makeRequestDebounced = createDebounce(makeRequest, 200);

type GetCollisionsParams = {
  search?: string;
  status?: string[] | string;
  page?: number;
  itemsPerPage?: number;
  orderBy?: string;
};

export async function getCollisions({
  search = "",
  status = [],
  page = 1,
  itemsPerPage = 10,
  orderBy = "-updatedAt",
}: GetCollisionsParams = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
  });

  // converte o status para string
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }

  if (search) params.append("search", search);
  if (orderBy) params.append("orderBy", orderBy);
  if (statusParam) params.append("filters[status]", statusParam);

  const url = `${API_URL}/?${params.toString()}`;

  const result = (await makeRequestDebounced(url)) as ApiResponseType<Collision[]> & {
    totalItems: number;
    pageTotalItens?: number;
  };

  return {
    ok: result.ok,
    data: result.data || [],
    totalItems: result.totalItems || 0,
    pageTotalItens: result.pageTotalItens || 0,
  };
}
// função para buscar dados de colisão por ID da colisão
export async function getCollisionByVehicle(collisionId: string) {
  const url = `${API_URL}/${collisionId}`;
  return (await makeRequestDebounced(url)) as ApiResponseType<Collision>;
}
// função para buscar detalhes completos da colisão, incluindo registros visuais
export async function getCollisionDetails(collisionId: string) {
  const url = `${API_URL}/details/${collisionId}`;
  return (await makeRequestDebounced(url)) as ApiResponseType<{
    collision: Collision;
    vehicleVisualRecord?: unknown | null;
    maintenanceVisualRecord?: unknown | null;
  }>;
}
